<template>
    <div>
        <div class="prices">
            <div class="price" v-if="!hasMissingFields && calculationResult != null">
                <p>Vehicle {{ index + 1 }}:</p>
                <p class="font-weight-bold">STD: <span>{{
                    this.calculationResult.prices.standard }}</span></p>
                <p class="font-weight-bold">EXP: <span>{{
                    this.calculationResult.prices.expedited }}</span></p>
                <p class="font-weight-bold">ENC: <span>{{
                    this.calculationResult.prices.standard +
                    parseInt(this.calculationResult.transportType.enclosed) }}</span></p>
                    <p class="font-weight-bold">CPAY: <span>{{
                        this.calculationResult.prices.base }}</span></p>
            </div>
            <div v-else>
                <div class="mt-2 alert alert-warning">
                    Fill vehicle details first. {{ calculationResult }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';

export default {
    name: "VehicleCalculation",
    props: {
        pickup: {
            type: String,
        },
        delivery: {
            type: String,
        },
        vehicle: {
            type: [String, Number],
        },
        index: {
            type: Number,
        },
    },
    data() {
        return {
            calculationResult: null,
        };
    },
    computed: {
        hasMissingFields() {
            return !this.vehicle ||
                !this.pickup ||
                !this.delivery;
        },
    },
    methods: {
        async calculate() {
            if (this.hasMissingFields) return;
            const response = await ApiClient.calculations.get({
                params: { pickupLocation: this.pickup, deliveryLocation: this.delivery, vehicleTypeId: this.vehicle },
            });
            this.calculationResult = response.data.data.result;
        },
    },
    watch: {
        pickup(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.calculate();
            }
        },
        delivery(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.calculate();
            }
        },
        vehicle(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.calculate();
            }
        },
    },
    mounted() {
        this.calculate();
    },
};
</script>
<style scoped lang="scss">
.prices {
    .price {
        display: flex;
        gap: 12px;

        p {
            margin-bottom: 0;
        }
    }
}
</style>